import { BlogSection } from '@/types/blog';

// This section is handled by the FAQ accordion system
// The FAQ data is located in src/data/faq/souveraenitaet-komplexitaet-faq.ts
export const faq: BlogSection = {
  id: 'faq',
  title: '',
  content: ''
};
